import { gql } from '@apollo/client/core'

export const GET_PATIENTS = gql`
  query GetPatients {
    patients {
      id
      firstName
      lastName
      gender
      dateOfBirth
      employeeNumber
    }
  }
`

export const GET_CLINIC_PATIENTS = gql`
  query GetClinicPatients($clinicId: ID!) {
    clinicPatients(clinicId: $clinicId) {
      id
      firstName
      lastName
      gender
      dateOfBirth
      employeeNumber
    }
  }
`

export const GET_PATIENT = gql`
  query GetPatient($patientId: ID!) {
    patient(patientId: $patientId) {
      id
      firstName
      middleNames
      lastName
      gender
      dateOfBirth
      idNumber
      passportNumber
      employeeNumber
      allergies
      surgeries
      chronics
      phoneNumber
      alternatePhone
      email
      addressLine1
      addressLine2
      city
      stateOrProvince
      postalCode
      country
      emergencyContactName
      emergencyContactPhone
      createdAt
      updatedAt
    }
  }
`

export const GET_CONSULTS = gql`
  query GetConsultsByPatient($patientId: ID!) {
    consults(patientId: $patientId) {
      id
      consultType
      prescription
      notes
      temperature
      bloodPressureSystolic
      bloodPressureDiastolic
      pulse
      patientHistory
      oxygenSaturation
      bloodGlucoseLevel
      hemoglobinLevel
      malariaTestResult
      hivRapidTestResult
      cholesterolLevel
      uricAcidLevel
      treatmentPlan
      weight
      icd10Code
      transcript
      assessment
      
      # --- New Urine Analysis Fields ---
      urineGlucose
      urineProtein
      urineKetone
      urineBlood
      urineNitrite
      urineLeukocytes
      urineBilirubin
      urineUrobilinogen
      urinePh
      urineSpecificGravity
      
      clinic {
        name
      }
      createdAt
      patient {
        id
        firstName
        lastName
        phoneNumber
        idNumber
        addressLine1
        addressLine2
        city
        stateOrProvince
        postalCode
        country
      }
      consultNotes {
        content
        createdAt
        user {
          firstName
          lastName
        }
      }
      user {
        firstName
        lastName
      }
      status
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      id
      email
      firstName
      lastName
    }
  }
`

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      email
      firstName
      lastName
    }
  }
`

export const GET_CLINICS = gql`
  query GetClinics {
    clinics {
      id
      name
      location
    }
  }
`

export const GET_CLINIC = gql`
  query GetClinic($clinicId: ID!) {
    clinic(clinicId: $clinicId) {
      id
      name
      location
    }
  }
`